import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: { display: "flex", flexWrap: "wrap", },

  floatingButton: {
    transition: "transform 0.30s",
    "&:hover": { transform: "translateY(-5px)", },
  },
}));

const GeneralMessageModal = ({ open, onClose, title, message }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={onClose} scroll="paper" maxWidth="sm" fullWidth>
        <DialogTitle>{title}</DialogTitle>

        <DialogContent dividers>
          <span>{message}</span>
        </DialogContent>

        <DialogActions>
          <Button
            color="inherit"
            variant="outlined"
            className={classes.floatingButton}
            onClick={onClose}
          >
            {i18n.t("generalMessageModal.buttons.cancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default GeneralMessageModal;
